import * as tslib_1 from "tslib";
import ComposeBottom from './ComposeBottom';
import { findComposePlugins } from 'owa-mail-compose-store/lib/plugins/ComposePlugins';
import { observer } from 'mobx-react';
import isReadingPaneCardUIEnabled from 'owa-mail-feature-flags/lib/isReadingPaneCardUIEnabled';
import * as React from 'react';
var styles = require('./Dock.scss');
var classNames = require('classnames/bind').bind(styles);
function getDockContainerClassName(isTop, isInlineCompose) {
    return classNames(styles.dockContainer, isReadingPaneCardUIEnabled() && styles.cardUI, {
        topPart: isTop,
        bottomPart: !isTop,
        isInlineCompose: isInlineCompose,
    });
}
var Dock = /** @class */ (function (_super) {
    tslib_1.__extends(Dock, _super);
    function Dock() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Dock.prototype.render = function () {
        var viewState = this.props.viewState;
        if (viewState.docking.useStickyDocking) {
            return null;
        }
        var dockingViewState = viewState.docking;
        var topDockingClassName = classNames(styles.topDocking, {
            isInlineCompose: viewState.isInlineCompose,
        });
        var topDockInlineStyles = {
            width: dockingViewState.dockingWidth,
            left: -dockingViewState.scrollLeft,
            visibility: (dockingViewState.isTopDocking
                ? 'visible'
                : 'hidden'),
        };
        var bottomDockInlineStyles = {
            width: dockingViewState.dockingWidth,
            left: -dockingViewState.scrollLeft,
            bottom: dockingViewState.scrollBarHeight + dockingViewState.bottomDockingBottom,
            visibility: (dockingViewState.isBottomDocking
                ? 'visible'
                : 'hidden'),
        };
        var plugins = findComposePlugins(viewState);
        return (React.createElement("span", null,
            React.createElement("div", { style: topDockInlineStyles, className: getDockContainerClassName(true /*isTop*/, viewState.isInlineCompose) },
                React.createElement("div", { className: topDockingClassName })),
            React.createElement("div", { style: bottomDockInlineStyles, className: getDockContainerClassName(false /*isTop*/, viewState.isInlineCompose) },
                React.createElement(ComposeBottom, tslib_1.__assign({ plugins: plugins, isHidden: !dockingViewState.isBottomDocking }, this.props)))));
    };
    Dock = tslib_1.__decorate([
        observer
    ], Dock);
    return Dock;
}(React.Component));
export default Dock;
//# sourceMappingURL=Dock.js.map